import React from 'react'

export const ConfirmMessage = () => {
  return <div>Info: Bets cannot be cancelled once confirmed.</div>
}
